import { GETTASKTEMPLATE_SUCCESS, GETTASKTEMPLATE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getTaskTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETTASKTEMPLATE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETTASKTEMPLATE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getTaskTemplateReducer;
